var _path, _circle;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgEntitySuspectSelected = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  height: 48,
  viewBox: "0 -960 960 960",
  width: 48,
  fill: "#EA3323"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M331.15-280.87 480-429.72l148.85 148.85 50.28-50.28L530.28-480l148.85-148.85-50.28-50.28L480-530.28 331.15-679.13l-50.28 50.28L429.72-480 280.87-331.15l50.28 50.28ZM479.57-62.8q-85.45 0-161.64-32.92-76.2-32.93-132.74-89.47-56.54-56.54-89.47-132.83-32.92-76.3-32.92-161.95 0-86.54 32.98-162.65 32.98-76.12 89.77-132.94 56.8-56.83 132.75-89.35 75.95-32.52 161.2-32.52 86.63 0 163.07 32.5 76.45 32.5 133.04 89.31 56.59 56.81 89.21 133.1 32.61 76.28 32.61 163.06 0 85.77-32.52 161.46-32.52 75.69-89.35 132.46-56.82 56.78-133.05 89.76Q566.28-62.8 479.57-62.8Z"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 480,
  cy: -480,
  r: 440,
  fill: "#fff",
  fillOpacity: 0.1
})));

export { SvgEntitySuspectSelected as ReactComponent };
export default __webpack_public_path__ + "aea2bd0f14d9758f006ebd4f0c66dd36.svg";